<template>
  <div class="dialog-wrap">
    <el-dialog title="题库选择"
               :close-on-click-modal="false"
               append-to-body
               :visible.sync="dialogVisible"
               @close="handleClose">
      <div class="content-wrap">
        <div style="display: flex;width: 100%;justify-content: end;margin-bottom:10px;">
          <el-button type="primary"
                     @click="examBankChooseDialog=true">添加</el-button>
        </div>

        <div class="right">
          <el-table class="result"
                    :data="results"
                    tooltip-effect="dark"
                    size="mini">
            <el-table-column prop="id"
                             label="ID"
                             width="60"
                             align="center">
            </el-table-column>
            <el-table-column prop="name"
                             label="名称"
                             min-width="160"
                             align="center">
              <template slot-scope="scope">
                {{scope.row.name || scope.row.title}}
              </template>
            </el-table-column>
            <el-table-column label="缩略图"
                             min-width="160"
                             align="center">
              <template slot-scope="scope">
                <img :src="scope.row.picture_url"
                     style="height:50px;"
                     alt="">
              </template>
            </el-table-column>
            <el-table-column label="价格"
                             prop="price"
                             min-width="120"
                             align="center">
            </el-table-column>
            <el-table-column label="参考价格"
                             prop="market_price"
                             min-width="120"
                             align="center">
            </el-table-column>
            <el-table-column label="购买人数"
                             prop="user_count"
                             min-width="120"
                             align="center">
            </el-table-column>
            <el-table-column label="创建时间"
                             min-width="160"
                             align="center">
              <template slot-scope="scope">
                <span>{{$moment(scope.row.create_time).format('YYYY.MM.DD')}}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态"
                             min-width="120"
                             align="center">
              <template slot-scope="scope">
                <span>{{scope.row.status?'已发布':'未发布'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             min-width="110"
                             align="center"
                             fixed="right">
              <template slot-scope="scope">
                <el-button type="primary"
                           size="mini"
                           @click="deleteById(scope.row.id)">
                  删除
                </el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
      <div class="footer">
        <el-pagination background
                       small
                       layout="total, prev, pager, next, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @current-change="handlePageChange"></el-pagination>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>

        <el-button type="primary"
                   @click="handleConfirm">确定</el-button>
      </div>
    </el-dialog>
    <ExamBankChoose :visible="examBankChooseDialog"
                    @close="examBankChooseDialog = false"
                    :goods="allresults"
                    :editRow="editRow"
                    type='multiple'
                    @submit="updataResults"
                    :chooseable="true" />
  </div>
</template>

<script>
import ExamBankChoose from '@/components/dialog/examCompose/ExamBankChoose.vue'
import { examComposeEdit, examList } from '@/api/exam'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editRow: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    ExamBankChoose,
  },
  data() {
    return {
      dialogVisible: this.visible,
      results: [],
      allresults: [],
      examBankChooseDialog: false,
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        is_all: 1,
      },
      pageTotal: 10,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    editRow(val) {
      console.log('editRow', val)
      this.$set(this.query, 'exam_compose_id', val.id)
      this.updataResults()
    },
  },
  methods: {
    updataResults() {
      this.fetchList()
      this.fetchAllList()
    },
    handleConfirm() {
      this.$emit('submit')
      this.$emit('close')
    },
    fetchList() {
      examList(this.query).then((res) => {
        this.results = res.list
        this.pageTotal = res.count
      })
    },
    fetchAllList() {
      let params = {
        isPaging: 0,
        exam_compose_id: this.editRow.id,
      }
      examList(params).then((res) => {
        this.allresults = res.list
      })
    },
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('close')
    },
    savegood(val) {
      this.results = val.goods
    },
    doeidtExamCompose() {
      let idarr =
        Array.isArray(this.results) && this.results.length
          ? this.results.map((exambank) => exambank.id)
          : []
      const params = {
        id: this.editRow.id,
        arr_exam_id: idarr,
      }
      examComposeEdit(params)
        .then((res) => {
          this.$message.success('删除成功')
          this.updataResults()
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    deleteById(id) {
      console.log(id, 'id')
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.results = this.results.filter((item) => item.id !== id)
          this.doeidtExamCompose()
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  // /deep/ .el-dialog__body {
  //   padding-top: 20px;
  // }

  .content-wrap {
    display: flex;
    width: 100%;
    flex-direction: column;

    .right {
      flex: 1;
      overflow: auto;
    }
  }
  .search-wrap {
    margin-bottom: -8px;

    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
      margin-bottom: 10px;
    }
  }
  .result {
    margin-top: 10px;
  }
  .selected-tags-wrap {
    margin-top: 16px;
    padding: 12px;
    background-color: #f5f7fa;
    border-radius: 4px;

    .selected-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      .selected-title {
        font-size: 14px;
        font-weight: 500;
        color: #303133;
      }
    }

    .selected-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      max-height: 120px;
      overflow-y: auto;

      .selected-tag {
        cursor: default;

        /deep/ .el-tag__close {
          cursor: pointer;
        }
      }
    }
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}
</style>
